/* 🤖 this file was generated by svg-to-ts */
export const siriusCurrencyDollarSimple: {
  name: 'currency_dollar_simple';
  data: string;
} = {
  name: 'currency_dollar_simple',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M18.75 15.75a4.504 4.504 0 0 1-4.5 4.5h-1.5v1.5a.75.75 0 1 1-1.5 0v-1.5h-1.5a4.504 4.504 0 0 1-4.5-4.5.75.75 0 1 1 1.5 0 3 3 0 0 0 3 3h4.5a3 3 0 0 0 0-6H10.5a4.5 4.5 0 1 1 0-9h.75v-1.5a.75.75 0 1 1 1.5 0v1.5h.75a4.505 4.505 0 0 1 4.5 4.5.75.75 0 1 1-1.5 0 3 3 0 0 0-3-3h-3a3 3 0 1 0 0 6h3.75a4.504 4.504 0 0 1 4.5 4.5Z" fill="currentColor"/></svg>`
};
